module.exports = __webpack_public_path__ + "static/img/ESGS2021.311d102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ESGS2021.png
// module id = fxJ9
// module chunks = 1